module.exports = __webpack_public_path__ + "img/P150T_weapon_56.6192b459.png";